var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-bar"},[_c('transition',{attrs:{"name":"appear"}},[(_vm.isOpen)?_c('div',{staticClass:"status-bar-panel d-flex justify-content-between p-3"},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }